import clsx from "clsx"
import React from "react"
import { BaseComponentWithChildrenProps } from "../../utils"

/**
 * @description 태그/뱃지 컴포넌트. 상태 라벨, 카테고리, 숫자 뱃지 등에 사용
 * @example
 * <TTag color="default" size="medium">New</TTag>
 * <TTag color="line" size="small">Category</TTag>
 * <TTag circle size="small">3</TTag>
 */
interface TTagProps extends Omit<BaseComponentWithChildrenProps, "id" | "dataAttributes"> {
	/**
	 * 태그 색상 스타일
	 * @default "default"
	 * @ai-style "default" - 반투명 배경(bg-g0/20), 기본 텍스트
	 * @ai-style "line" - 투명 배경, 회색 테두리(border-g300)
	 */
	color?: "default" | "line"
	/**
	 * 태그 크기
	 * @default "medium"
	 * @ai-style "large" - 높이 28px, text-base
	 * @ai-style "medium" - 높이 24px, text-sm
	 * @ai-style "small" - 높이 20px, 10px 텍스트
	 */
	size?: "large" | "medium" | "small"
	/** 원형 태그 (숫자 뱃지용, aspect-square) */
	circle?: boolean
}

export const TTag = React.memo((props: TTagProps) => {
	const { className, color = "default", size = "medium", circle, children } = props

	return <div className={clsx("TTag", color, size, { circle }, className)}>{children}</div>
})

TTag.displayName = "TTag"
